<template>
  <div class="layout-v3">
    <slot></slot>
    <button
      v-if="agentInfo && Object.keys(agentInfo).length > 0"
      class="chat-agent"
      aria-label="Open Chat"
      @click="openChat"
    >
      <IconChat class="icon-chat"></IconChat>
    </button>
    <LiveChatWidget
      v-if="agentInfo.live_chat_key"
      :license="agentInfo.live_chat_key"
      visibility="hidden"
      @visibility-changed="onVisibilityChanged"
    >
    </LiveChatWidget>
    <dialog-anonymous-contact-agent ref="dialogAnonymousContactAgent2"></dialog-anonymous-contact-agent>
  </div>
</template>

<script>
import "@/css/v3/style.css";
import "@/css/v3/bootstrap.css";
import "@/css/v3/animate.min.css";
import dialogAnonymousContactAgent from '@/components/Dialog/DialogAnonymousContactAgent'
import IconChat from '@/components/Icon/IconChat.vue'
import { anonymous as apiAnonymous } from '@/apis'
import { LiveChatWidget } from '@livechat/widget-vue/v2' 

import {
  ROUTE_LOGIN,
  ROUTE_OTP,
  ROUTE_RESET_PASSWORD
} from '@/const/route'

export default {
  name: "App",  
  components: {
    dialogAnonymousContactAgent,
    IconChat,
    LiveChatWidget,
  },
  data: () => ({   
    agentInfo: {},
  }), 
  computed : {
    pathName () {
      return this.$route.name
    }, 
    title () {
      return this.pathName === ROUTE_LOGIN ? 'เข้าสู่ระบบ' : 
      this.pathName === ROUTE_OTP ? 'เตรียมยืนยันรหัส OTP ผ่านโทรศัพท์' : 
      this.pathName === ROUTE_RESET_PASSWORD ? 'ยืนยัน OTP เพื่อรีเซ็ทรหัสผ่าน' : null
    },
    agent_name () {
      return this.$route.query.agent_name;
    },
  },
  async created () {
    await this.getAgentInfo()
  },
  async mounted () {

    if (this.agent_name) {
      localStorage.setItem('agent-name', this.agent_name);
    }
  },
  methods: {
    async getAgentInfo (){
      const [err, data] = await apiAnonymous.getAgentInfo({ domain: window.location.host })
      
      if (err) {
        return
      }     
      this.agentInfo = data 
    },
    onVisibilityChanged (event) {
      switch (event.visibility) {
        case "maximized":
          break;
        case "minimized":
          window.LC_API.hide_chat_window();
          break;
        case "hidden":
          break;
      }
    },
    openChat () {
      this.$refs.dialogAnonymousContactAgent2.open()
    }
  } 
};
</script>

<style >

.layout-v3 {
  min-height: 100%;
  display: flex;
  justify-content: center;
  /* align-items: center; */
}


.layout-v3 a {
  color: #fff !important
}

.theme--light.v-application {
   background: transparent !important;
}

</style>